import type { CardProps } from '@mui/material/Card';
import type { ChartOptions } from '../components/chart';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import CardHeader from '@mui/material/CardHeader';

import { fCurrency } from '../utils/format-number';

import { Chart, useChart, ChartLegends } from '../components/chart';
import { IAnalyticsState } from '../../../redux/analytics/analytics.types';
import { useOutletContext } from '../../../providers';
import { StandardCard } from '../../../Components/Card';

// ----------------------------------------------------------------------

type Props = CardProps & {
  title?: string;
  subheader?: string;
  chart: {
    colors?: string[];
    icons?: React.ReactNode[];
    series: {
      label: string;
      value: number;
    }[];
    options?: ChartOptions;
  };
  overview: IAnalyticsState["expense_categories_list"]["overview"]
};

export function BankingExpensesCategories({ title, subheader, chart, overview, ...other }: Props) {
  const { OUTLET_CURRENCY_SYMBOL } = useOutletContext()
  const theme = useTheme();

  const chartColors = chart.colors ?? [
    theme.palette.secondary.dark,
    theme.palette.error.main,
    theme.palette.primary.main,
    theme.palette.warning.main,
    theme.palette.info.dark,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.warning.dark,
  ];

  const chartSeries = chart.series.map((item) => item.value);

  const chartOptions = useChart({
    chart: { offsetY: 12 },
    colors: chartColors,
    labels: chart.series.map((item) => item.label),
    stroke: { width: 1, colors: [theme.palette.background.paper] },
    fill: { opacity: 0.88 },
    tooltip: { y: { formatter: (value: number) => `${OUTLET_CURRENCY_SYMBOL}${value}` } },
    plotOptions: { pie: { donut: { labels: { show: false } } } },
    ...chart.options,
  });

  return (

    <StandardCard heading={title} >
 <Box
        sx={{
          pt: 4,
          pb: 3,
          rowGap: 3,
          columnGap: 5,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Chart
          type="polarArea"
          series={chartSeries}
          options={chartOptions}
          width={{ xs: 240, md: 280 }}
          height={{ xs: 240, md: 280 }}
        />

        <ChartLegends
          colors={chartOptions?.colors}
          labels={chartOptions?.labels}
          icons={chart.icons}
          sublabels={chart.series.map((item) => `${OUTLET_CURRENCY_SYMBOL}${item.value}`)}
          sx={{ gap: 2.5, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}
        />
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Box
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        sx={{ textAlign: 'center', typography: 'h4' }}
      >
        <Box sx={{
          py: 2,
          // borderRight: `dashed 1px ${theme.vars.palette.divider}`
        }}>
          <Box sx={{ mb: 1, typography: 'body2', color: 'text.secondary' }}>Categories</Box>{overview[0]?.categories || 0}
        </Box>

        <Box sx={{ py: 2 }}>
          <Box sx={{ mb: 1, typography: 'body2', color: 'text.secondary' }}>Total</Box>
          {`${OUTLET_CURRENCY_SYMBOL}${overview[0]?.total_amount || 0}`}
        </Box>
      </Box>

    </StandardCard>

    // <Card {...other} sx={{  boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",}}>
    //   <CardHeader title={title} titleTypographyProps={{
    //     variant: "h3"
    //   }} subheader={subheader} />

     
    // </Card>
  );
}
